var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "blubber_thread",
      class: {
        dragover: _vm.dragging,
      },
      attrs: {
        id: _vm.blubberThreadId,
      },
      on: {
        dragover: function dragover($event) {
          $event.preventDefault()
          return _vm.dragover.apply(null, arguments)
        },
        dragleave: function dragleave($event) {
          $event.preventDefault()
          return _vm.dragleave.apply(null, arguments)
        },
        drop: function drop($event) {
          $event.preventDefault()
          return _vm.onDrop.apply(null, arguments)
        },
      },
    },
    [
      _vm.threadNotifications
        ? _c("ThreadSubscriber", {
            staticClass: "hidden-medium-up",
            attrs: {
              followed: _vm.threadFollowed,
            },
            on: {
              "subscribe-thread": _vm.onSubscribeThread,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scrollable",
          staticClass: "scrollable_area",
          class: {
            scrolled: _vm.scrolled,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "all_content",
            },
            [
              _vm.emptyBlubber
                ? _c(
                    "div",
                    {
                      staticClass: "empty_blubber_background",
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$gettext("Starte die Konversation jetzt!"))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ol",
                {
                  staticClass: "comments",
                  attrs: {
                    "aria-live": "polite",
                  },
                },
                [
                  _vm.moreCommentsUp
                    ? _c(
                        "li",
                        {
                          staticClass: "more",
                        },
                        [
                          _c("studip-asset-img", {
                            attrs: {
                              file: "loading-indicator.svg",
                              width: "20",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.sortedComments, function (comment) {
                    return _c("BlubberComment", {
                      key: comment.id,
                      attrs: {
                        comment: comment,
                        editing:
                          _vm.commentEditing &&
                          comment.id === _vm.commentEditing.id,
                      },
                      on: {
                        "answer-comment": _vm.onAnswerComment,
                        "change-comment": _vm.onChangeComment,
                        "edit-comment": _vm.onEditComment,
                        "remove-comment": _vm.onRemoveComment,
                      },
                    })
                  }),
                  _vm._v(" "),
                  _vm.moreCommentsDown
                    ? _c(
                        "li",
                        {
                          staticClass: "more",
                        },
                        [
                          _c("studip-asset-img", {
                            attrs: {
                              file: "loading-indicator.svg",
                              width: "20",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.threadCommentable
        ? _c("BlubberComposer", {
            ref: "composer",
            attrs: {
              placeholder: _vm.writerTextareaPlaceholder,
              progress: _vm.uploadProgress,
            },
            on: {
              change: _vm.onChangeComposerText,
              "add-posting": _vm.onAddPosting,
              "edit-previous": _vm.onEditPrevious,
              "pick-files": _vm.onPickFiles,
            },
            model: {
              value: _vm.composerText,
              callback: function callback($$v) {
                _vm.composerText = $$v
              },
              expression: "composerText",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }